/**
 * Texts (`en`) of the «training» slice of Quality and HACCP (OBR-170, food handler training). Own file: `en.ts` is
 * not touched. The three languages must have the same keys (i18n.test.ts); no literal text in the views.
 */

export const trainingEn = {
  'backoffice.qualityTraining': {
    // Column and filter of the Team lists (Users and Operators).
    columnHeader: 'Training',
    filterLabel: 'Training',
    filterAll: 'All',
    rowAction: 'Training',
    openFor: 'Training of {{name}}',
    // A person’s status (derived from the dates, never stored).
    statusValid: 'Valid',
    statusExpiring: 'Expires soon',
    statusExpired: 'Expired',
    statusMissing: 'No training',
    // Topics.
    topicFoodHandler: 'Food handler',
    topicAllergens: 'Allergens',
    topicOther: 'Other',
    // The person’s dialog.
    dialogTitle: 'Training of {{name}}',
    dialogHint:
      'The person’s courses and certificates. The status follows the training that covers the longest; if any of them never expires, it is always valid.',
    dialogStatus: 'Status',
    empty: 'No training recorded yet.',
    loadError: 'The training records could not be loaded.',
    readOnly: 'Only administration and quality can record, edit or deactivate training.',
    add: 'Add training',
    edit: 'Edit',
    remove: 'Deactivate',
    // One training in the list.
    rowTrainedOn: 'Done on {{date}}',
    rowProvider: 'Provider: {{provider}}',
    rowExpiresOn: 'Expires on {{date}}',
    rowNoExpiry: 'Does not expire',
    rowNoCertificate: 'No certificate',
    certificateOpen: 'Open the certificate',
    certificateOpenError: 'The certificate could not be opened. Please try again.',
    // Form.
    formTitleNew: 'New training',
    formTitleEdit: 'Edit the training',
    fieldTopic: 'Topic',
    fieldTopicLabel: 'Which training',
    fieldTopicLabelHint: 'Required when the topic is “Other”.',
    fieldTrainedOn: 'Training date',
    fieldProvider: 'Provider or trainer',
    fieldExpiresOn: 'Expires on',
    fieldExpiresOnHint: 'Renewal date. Leave empty if the training does not expire.',
    fieldCertificate: 'Certificate',
    fieldCertificateHint: 'PDF or image, up to 10 MB.',
    certificateCurrent: 'Attached certificate',
    certificateNew: 'New: {{name}}',
    certificateRemove: 'Remove the certificate',
    fieldNotes: 'Notes',
    // Validation and network errors (never silenced).
    errorTopicLabelRequired: 'Say which training it is.',
    errorTrainedOnRequired: 'The training date is required.',
    errorTrainedOnFuture: 'The training date cannot be in the future.',
    errorDateInvalid: 'The date is not valid.',
    errorExpiresBeforeTrained: 'The expiry cannot be earlier than the training date.',
    errorFileType: 'The certificate must be a PDF or an image.',
    errorFileTooLarge: 'The certificate cannot exceed 10 MB.',
    errorUpload: 'The certificate could not be uploaded. Please try again.',
    errorSave: 'The training could not be saved. Please try again.',
    errorDelete: 'The training could not be deactivated. Please try again.',
    // Logical deactivation (reason required).
    deleteTitle: 'Deactivate the training',
    deleteBody:
      'The training will stop counting towards the person’s status. It is kept on record with the reason.',
    deleteCta: 'Deactivate',
  },
} as const;
